export type AvailablePageTemplates = {
  documentType: string;
};

export const PageTemplates: AvailablePageTemplates[] = [
  {
    documentType: 'pageHome',
  },
  {
    documentType: 'pageWaitlistLandingPage',
  },
  {
    documentType: 'pageWaitlistThankYou',
  },
  {
    documentType: 'pageLegal',
  },
  {
    documentType: 'pageSalesPage',
  },
  {
    documentType: 'pageBlogOverview',
  },
  {
    documentType: 'pageBlogSingle',
  },
];
